import { Phone, Brain, FileText, Bell } from "lucide-react";

const steps = [
  ["Vous choisissez quand Immovox répond","En débordement, hors horaires ou en continu.",Phone],
  ["La conversation reste naturelle","L'assistant identifie l'intention et pose les questions utiles.",Brain],
  ["Le contexte est structuré","Coordonnées, motif, informations métier et synthèse.",FileText],
  ["Votre équipe reprend la main","Vous recevez l'information et rappelez avec le bon contexte.",Bell],
];

const HowItWorksSection = () => (
  <section id="how-it-works" className="bg-[hsl(157_24%_15%)] py-14 text-background md:py-16 lg:py-20">
    <div className="mx-auto max-w-[1344px] px-5 md:px-8">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[.18em] text-background/60">Comment ça marche</p>
          <h2 className="mt-5 max-w-[390px] text-4xl font-semibold tracking-[-.04em] md:text-[48px] md:leading-[1.02]">Vous restez l'agent. Immovox prépare le terrain.</h2>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          {steps.map(([title,desc,Icon],i) => {
            const I = Icon as typeof Phone;
            return (
              <div key={title as string} className="grid grid-cols-[44px_1fr] gap-5 border-t border-background/18 py-6 md:grid-cols-[56px_1fr_1.1fr]">
                <span className="font-mono text-xs text-background/60">0{i+1}</span>
                <div className="flex gap-3"><I className="mt-0.5 h-5 w-5 text-background/78" /><h3 className="text-base font-semibold">{title as string}</h3></div>
                <p className="col-start-2 text-[14px] leading-6 text-background/72 md:col-start-auto">{desc as string}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
export default HowItWorksSection;